<template>
  <layout-basic>
    <page-hero
      title="Expert Advice for Growing Businesses"
      lead="Free guides, webinars, videos and insights to help you build a better learning culture."
    />

    <section class="resources-hub">
      <v-container>
        <h2 class="font-sora resources-hub__heading">Explore resources</h2>
        <div class="resources-hub__grid">
          <router-link
            v-for="item in links"
            :key="item.to"
            :to="item.to"
            class="resources-hub__card"
          >
            <strong>{{ item.title }}</strong>
            <span>{{ item.blurb }}</span>
          </router-link>
        </div>
      </v-container>
    </section>

    <standard-cta
      title="Learn something new today."
      lead="Watch the 4-minute demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Resources',
  components: {
    LayoutBasic,
    PageHero,
    StandardCta,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Expert Advice for Growing Businesses | IMPROVE',
      description:
        'Free guides, webinars, videos and insights to help you build a better learning culture.',
      path: '/resources',
    });
  },
  data() {
    return {
      links: [
        {
          title: 'Blogs',
          blurb: 'Practical insights for growing businesses.',
          to: '/blog',
        },
        {
          title: 'Guides',
          blurb: 'Step-by-step advice on building a learning culture.',
          to: '/resources/guides',
        },
        {
          title: 'Webinars',
          blurb: 'Upcoming live webinars, with recordings to follow.',
          to: '/resources/webinars',
        },
        {
          title: 'Downloads',
          blurb: 'Helpful resources you can take away.',
          to: '/resources/downloads',
        },
        {
          title: 'FAQs',
          blurb: 'Answers to common questions before you buy.',
          to: '/faq',
        },
        {
          title: 'Watch the 4-minute demo',
          blurb: 'See IMPROVE in action.',
          to: '/watch-demo',
        },
        {
          title: 'IMPROVE Live',
          blurb: 'Book a free live webinar with the IMPROVE team.',
          to: '/improve-live',
        },
      ],
    };
  },
};
</script>

<style scoped>
.resources-hub {
  padding: 24px 0 48px;
}

.resources-hub__heading {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px;
}

.resources-hub__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 980px;
  margin: 0 auto;
}

.resources-hub__card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 22px 18px;
  text-decoration: none;
  color: var(--brand-navy, #002458);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.resources-hub__card:hover {
  border-color: var(--brand-teal, #08a0a8);
  box-shadow: 0 8px 24px rgba(0, 36, 88, 0.08);
  color: var(--brand-navy, #002458);
}

.resources-hub__card strong {
  font-size: 17px;
}

.resources-hub__card span {
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
  line-height: 1.45;
}

@media screen and (max-width: 900px) {
  .resources-hub__grid {
    grid-template-columns: 1fr;
  }
}
</style>
